import lessvars from './common/modules/lessvars';

const theme = {
  less: lessvars,
};

export default theme;
